import { AppliedToplineItemFragment, AppliedToplines } from 'generated/graphql';

import { isNilOrEmpty } from 'helpers';

export const extractToplines = (appliedToplines: AppliedToplines): AppliedToplineItemFragment.Fragment[] => {
  // no toplines return empty array
  if (isNilOrEmpty(appliedToplines)) {
    return [];
  }

  // This is equivialnt to
  // const item1 = appliedToplines.item1;
  // const item2 = appliedToplines.item2;
  // ...
  const { item1, item2, item3, item4, item5 } = appliedToplines;

  // Put the items into an array in the proper order
  const allToplines = [item1, item2, item3, item4, item5]
    .filter(item => !!item); // remove empty items

  // Return the result
  return allToplines;
};
